@if (scanningAgentFeatureEnabled && (canSeeScanningAgent$ | async)) {
  <div class="margin-top">
    <div class="label">{{ 'scanning_agent' | translate }}</div>
    <p class="mb-1">{{ 'scanning_agent_setup_description' | translate }}</p>

    <ds-banner
      data-test-id="scanning-agent-banner"
      [state]="DsBannerState.warning"
      [showTitle]="false"
      [showAction]="false"
      [showCloseButton]="false"
    >
      <div ds-banner-body>
        <p class="mb-1">
          <span class="d-block" data-test-id="scanning-agent-banner-msg">{{ 'scanning_agent_setup_required' | translate }}</span>

          <ds-link [external]="true" href="https://client.levelaccess.com/hc/en-us/articles/31176263877143/">
            {{ 'open_agent_configuration_instructions' | translate }}
          </ds-link>
        </p>
      </div>
    </ds-banner>

    <app-toggle-switch
      name="ScanningAgentSwitch"
      [disabled]="cannotToggleScanningAgent$ | async"
      data-test-id="scanning-agent-switch"
      [value]="value"
      (valueChange)="onValueChange($event)"
      switchContainerClass="d-flex align-items-center mt-2"
    >
      <span class="switch-label">{{ 'enable_scanning_agent_switch' | translate }}</span>
    </app-toggle-switch>
  </div>
}
